import formatDistanceStrict from 'date-fns/formatDistanceStrict'

export default function formatDateRelative(fromDate, toDate = new Date()) {
  const distance = formatDistanceStrict(fromDate, toDate)
  return `${distance} ago`
}
